import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import Header from './Header';
import Footer from './Footer';
import { Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, Link } from 'react-router-dom';
import RoomImageSlider from './RoomImageSlider';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';

const Viewroomdetails = () => {
const location = useLocation();
const navigate = useNavigate();
const searchParams = new URLSearchParams(location.search);

const formatDateForUrl = (date) => {
  if (typeof date === 'string') {
    return date;
  }
  return moment(date).format('DD-MM-YYYY');
};

const checkInDate = searchParams.get('checkInDate');
const checkOutDate = searchParams.get('checkOutDate');
const totalrooms = searchParams.get('totalrooms');
const totalguest = searchParams.get('totalguest');
const id = searchParams.get('id');
const [roomDetails, setRoomDetails] = useState(null);
const [relatedRooms, setRelatedRooms] = useState([]);
const [error, setError] = useState(null);
const [popupVisible, setPopupVisible] = useState(false);
const [checkInDateState, setCheckInDate] = useState(
checkInDate ? new Date(moment(checkInDate, 'DD-MM-YYYY')) : null
  );
  const [checkOutDateState, setCheckOutDate] = useState(
  checkOutDate ? new Date(moment(checkOutDate, 'DD-MM-YYYY')) : null
  );  const [roomListings, setRoomListings] = useState([]);
const [rooms, setRooms] = useState([
  { id: 1, count: parseInt(totalguest) > 0 ? parseInt(totalguest) : 1 }
]);

  const incrementCount = (roomId) => {
  setRooms(rooms.map(room => 
  room.id === roomId ? { ...room, count: room.count + 1 } : room
    ));
  };

  const decrementCount = (roomId) => {
  setRooms(rooms.map(room => 
  room.id === roomId && room.count > 1 ? { ...room, count: room.count - 1 } : room
    ));
  };

  const addRoom = () => {
  const newId = Math.max(...rooms.map(r => r.id)) + 1;
  setRooms([...rooms, { id: newId, count: 1 }]);
  };

  const deleteRoom = () => {
  if (rooms.length > 1) {
  setRooms(rooms.slice(0, -1));
    }
  };
useEffect(() => {
if (checkInDate && checkOutDate && id) {
 const formattedCheckInDate = moment(checkInDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
 const formattedCheckOutDate = moment(checkOutDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
 const fetchData = async () => {
try {
const response = await axios.get(`https://api.abhyaranyan.com/api/Abhyaranyan/RoomDetailbyid`, {
params: {
checkInDate: formattedCheckInDate, 
checkOutDate: formattedCheckOutDate,
totalrooms,
totalguest,
id,
 },
});
setRoomDetails(response.data.data);
if (response.data.data.roomsList && response.data.data.roomsList.length > 0) {
const relatedRoomsList = response.data.data.roomsList
              .filter(room => room.id !== parseInt(id))
              .slice(0, 3);
            setRelatedRooms(relatedRoomsList);
          }
        } catch (err) {
          console.error(err);
          setError('Failed to fetch room details.');
        }
      };
      fetchData();
    }
  }, [checkInDate, checkOutDate, totalrooms, totalguest, id])
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
    document.body.removeChild(script);
    };
  }, []);
  
    const query = new URLSearchParams(location.search);
    
        useEffect(() => {
        const formatDateForApi = (date) => {
            if (!date) return '';
            const [day, month, year] = date.split('-');
            return `${year}-${month}-${day}`;
        };

        const fetchRooms = async () => {
            if (!checkInDate || !checkOutDate) return;
            
            try {
                const response = await axios.get('https://api.abhyaranyan.com/api/Abhyaranyan/RoomSearch', {
                    params: {
                        checkInDate: formatDateForApi(checkInDate),
                        checkOutDate: formatDateForApi(checkOutDate),
                        totalrooms,
                        totalguest,
                    }
                });

                if (response.data.rooms?.rooms) {
                  setRoomListings(response.data.rooms.rooms);
                }
            } catch (error) {
                console.error('Error fetching room data:', error);
                setError('Failed to fetch room listings. Please try again.');
            }
        };

        fetchRooms();
    }, [checkInDate, checkOutDate, totalrooms, totalguest]);  const handleSearch = () => {
        const totalrooms = rooms.length;
        const totalguest = rooms.reduce((total, room) => total + (room.count || 0), 0);
        
        if (totalguest === 0) {
            alert('Please select at least one guest');
            return;
        }

        const checkInFormatted = checkInDate ? formatDateForUrl(checkInDate) : formatDateForUrl(new Date());
        const checkOutFormatted = checkOutDate ? formatDateForUrl(checkOutDate) : formatDateForUrl(new Date());

        const queryParams = new URLSearchParams({
            checkInDate: checkInFormatted,
            checkOutDate: checkOutFormatted,
            totalrooms,
            totalguest,
            id: id || ''
        }).toString();

        navigate(`/Viewrooms?${queryParams}`);
    };
    const handlePayment = async () => {
    const firstName = document.getElementById('firstName').value;
    const lastName = document.getElementById('lastName').value;
    const email = document.getElementById('emailHelp').value;
    const contact = document.getElementById('mobile-no').value;
    const gender = document.getElementById('Gender').value;
    const address = document.getElementById('Address').value;
    if (!firstName || !lastName || !email || !contact || !gender || !address) {
    alert('Please fill all guest details before proceeding to payment.');
    return;
    }
    try {
      const response = await axios.post(`https://api.abhyaranyan.com/api/Abhyaranyan/RoomDetailbyid?id=${id}`, {
        roomid: id,
        firstName,
        lastName,
        gender,
        phone: contact,
        emailAddress: email,
        address,
        amount: roomDetails.amount,
        checkInDate: roomDetails.checkInDate,
        checkOutDate: roomDetails.checkOutDate,
        totalPerson: totalguest,
        numberofRooms: totalrooms,
        paymentMode_Id: 0,
        razorpayKey: 'rzp_test_BXjJAJuQSCxc3X',
        paymentId: 'temp_id',
        isPaymentStatus: true,
        order_Id: 'temp_order_id',
      });
      if (response.data.succeeded) {
        const { amount } = response.data.data;
        const options = {
        key: 'rzp_test_BXjJAJuQSCxc3X',
        amount: amount * 100,
        currency: 'INR',
        name: 'Abhyaranyan',
        description: 'Room Booking',
        handler: function (paymentResponse) {
        alert('Payment successful! Payment ID: ' + paymentResponse.razorpay_payment_id);
        alert('Booking Confirmed successfully!');
         },
        prefill: {
        name: `${firstName} ${lastName}`,
        email,
        contact,
       },
        notes: {
        address,
        },
        theme: {
        color: '#3399cc',
          },
        };
      const rzp1 = new window.Razorpay(options);
      rzp1.open();
      } else {
        alert('Booking failed. Please try again.');
      }
    } catch (error) {
      console.error('Booking failed:', error);
      alert('Booking failed. Please try again.');
    }
  };
  if (error) {
    return (
    <div className="container mt-5 text-center">
    <div className="alert alert-danger">{error}</div>
    </div>
    );
  }
  if (!roomDetails) {
    return (
    <div className="container mt-5 text-center">
   <div className="spinner-border text-primary" role="status">
   <span className="visually-hidden">Loading...</span>
   </div>
   </div>
    );
  }
  return (
    <div>
      <Header />
      <div className="container my-5">         
      <div className="row">
      <div className="col-lg-9">             
             <RoomImageSlider imageJson={roomDetails.imageJson} />
          </div>

<div className="row">
  <div className="col-lg-4 offset-lg-8 col-md-6 col-sm-12">
    
    <form onSubmit={handlePayment} style={{ width: '100%' }}>
      <Card className="p-4" style={{ marginLeft: '126px', marginTop: '-624px' }}>

         <div className="google-map rounded-3 overflow-hidden" style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.7168542751736!2d77.57823599999999!3d30.296953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929e9bd20fbb3%3A0xaa8296cf4a257c29!2sAbhyaranyan!5e0!3m2!1sen!2sin!4v1653647282959!5m2!1sen!2sin"
                      style={{ border: 0, width: '100%', height: '260px' }}
                      allowFullScreen=""
                      
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Location Map"
                    />
                  </div>                
        <h4>Book This Now</h4>
        {/* Check-in Date */}
        <div className="search-body mb-3">
          <label htmlFor="checkin"><h6>Check In</h6></label>
          <DatePicker
            id="checkin"
            selected={checkInDate}
            onChange={(date) => setCheckInDate(date)}
            placeholderText="Select Check-in Date"
            className="form-control"
            dateFormat="dd/MM/yyyy"
            required
          />
        </div>

        {/* Check-out Date */}
        <div className="search-body mb-3">
          <label htmlFor="checkout"><h6>Check Out</h6></label>
          <DatePicker
            id="checkout"
            selected={checkOutDate}
            onChange={(date) => setCheckOutDate(date)}
            placeholderText="Select Check-out Date"
            className="form-control"
            dateFormat="dd/MM/yyyy"
            required
          />
        </div>

        {/* Rooms & Guests Picker */}
        <div
          className="search-body mb-3"
          onClick={() => setPopupVisible(true)}
          style={{ cursor: "pointer" }}
        >
          <label><h6>Rooms & Guests</h6></label>
          <div className="form-control">
            {`${rooms.length} Room${rooms.length > 1 ? 's' : ''}, ${rooms.reduce((total, room) => total + room.count, 0)} Guest${rooms.reduce((total, room) => total + room.count, 0) > 1 ? 's' : ''}`}
          </div>
        </div>

        {/* Room & Guest Popup */}
        {popupVisible && (
          <div className="popup">
            <div className="popup-content">
              <div className="room-control">
                <h6>Rooms</h6>
                <h6>Guests</h6>
              </div>
              <hr />
              {rooms.map((room, index) => (
                <div key={room.id} className="room-control">
                  <span>Room {index + 1}</span>
                  <button
                    onClick={() => decrementCount(room.id)}
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                  >-</button>
                  <span className="mx-2">{room.count}</span>
                  <button
                    onClick={() => incrementCount(room.id)}
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                  >+</button>
                </div>
              ))}
              <hr />
              <div className="room-control">
                <div className="col-md-6 col-xs-6 text-center">
                  <button
                    onClick={deleteRoom}
                    className="btn btn-link text-danger p-0"
                    type="button"
                  >
                    Delete Room
                  </button>
                </div>
                <div className="col-md-6 col-xs-6 text-center">
                  <button
                    onClick={addRoom}
                    className="btn btn-link text-primary p-0"
                    type="button"
                  >
                    Add Room
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Button
  onClick={handleSearch}
  variant="danger"
  className="w-100 mt-4"
  type="submit"
>
  Book Now
</Button>

      </Card>
    </form>
  </div>
</div>


          </div>
  <section className="single-section bg-inner small-section">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="description-section">
          {/* Tab Navigation */}
          <div className="menu-top menu-up">
            <ul className="nav nav-tabs" id="top-tab" role="tablist">
              {["rooms", "about", "facility", "location", "reviews", "policies"].map((tab, index) => (
                <li className="nav-item" key={tab}>
                  <a
                    className={`nav-link ${index === 0 ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href={`#${tab}`}
                    role="tab"
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content */}
                    <div className="description-details tab-content" id="top-tabContent">
            {/* Rooms Tab */}
            <div class="menu-part tab-pane fade show active" id="rooms">
            <div style={{ background: "#f9f9f9" }}>
                <div className="container">
                    <div className="list-view row content grid">
                        {roomListings.length > 0 ? roomListings.map((room) => (
                            <div key={room.id} className="list-box col-12 popular grid-item wow fadeInUp">
                                <div className="list-img">
                                     <Link to={`/Viewroomdetails?${query}&id=${room.id}`}  className="img-link">
                                      <img
                                       src={`https://admin.abhyaranyan.com/RoomsUploadimage/${room.roomImage}`}
                                        className="img-fluid blur-up lazyload"
                                           alt={room.roomType}
                                           />
                                    </Link>
                                </div>
                                 <div className="list-content">
                                 <div className="offer-box">
                                 <i className="fas fa-fire"></i> {room.airCondition}
                                </div>
                                 <div>
                                   <h5>{room.roomType}</h5>
                                    <h5>{room.location}</h5>
                                    <p>{room.description}</p>
                                     <div className="rating">
                                      {[...Array(5)].map((_, index) => (
                                     <i key={index} className={`fas fa-star ${index < room.rating ? 'filled' : ''}`}></i>
                                       ))}
                                      <span>{room.reviews} reviews</span>
                                        </div>
                                          <div className="price">
                                          <p className="mb-0">
                                            {room.oldRent && <del>₹{room.oldRent}</del>}
                                            ₹{room.rent} <span>/ per night</span>
                                              </p>
                                         <p className="mb-0">Login & unlock a secret deal</p>
                                         </div>
                                          <Link 
                                          to={`/Viewrooms?${query}&id=${room.id}`} 
                                          className="btn btn-solid color1 book-now"
                                        >
                                          Book Now
                                        </Link>
                                          </div>
                                         </div>
                            </div>
                        )) : (
                            <div className="col-12 text-center py-5">
                              <p>No rooms available for the selected dates.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            </div>
            {/* About Tab */}
            <div className="tab-pane fade" id="about" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-4">
                  <div className="about">
                    <div className="mb-4">
                      <h5 className="fw-bold mb-2 text-start">Enjoy a luxurious experience!</h5>
                      <p style={{
                        textAlign: "justify",
                        maxWidth: "1000px",
                        maxHeight: "100px",
                        overflowY: "auto",
                        margin: "10px 0",
                        fontSize: "1rem",
                        lineHeight: "1.5"
                      }}>
                        A luxurious hotel in Dubai, Sea View is just 500 meters away from the main center.
                        Featuring palatial space, modern architecture and stylish interiors, this hotel
                        is an ideal choice for peaceful relaxation or a business trip.
                      </p>
                    </div>
                    <div className="mb-4">
                      <h5 className="fw-bold mb-2 text-start">Hotel Facilities</h5>
                      <p style={{ textAlign: "justify", width: "1000px", height: "100px", overflow: "auto", margin: "10px", fontSize: "1rem", lineHeight: "1.5" }}>
                        A luxurious hotel in Dubai, Sea view is just 500 meters away from the main center.
                        Featuring palatial space, modern architecture and stylish interiors, this hotel
                        is an ideal choice for a peaceful relaxation or a business trip.
                      </p>
                    </div>
                    <div className="mb-4">
                      <h5 className="fw-bold mb-2 text-start">Dining</h5>
                      <p style={{ textAlign: "justify", width: "1000px", height: "100px", overflow: "auto", margin: "10px", fontSize: "1rem", lineHeight: "1.5" }}>
                        The luxurious hotel in Dubai features an in-house restaurant and bar. Flame N Grill restaurant operates from 7:30 AM till midnight. It offers a multi-cuisine menu including Continental, Chinese, Indian, and Goan dishes. The Pool Deck BAR is a paradise with a range of beverages and a water fountain, providing a pleasant ambience to enjoy your drinks.
                      </p>
                    </div>
                    <div className="mb-4">
                      <h5 className="fw-bold mb-2 text-start">Room Facilities</h5>
                      <p style={{ textAlign: "justify", width: "1000px", height: "100px", overflow: "auto", margin: "10px", fontSize: "1rem", lineHeight: "1.5" }}>
                        This hotel has 150 air-conditioned rooms including 50 Superior Rooms, 30 Deluxe Rooms,
                        10 Super Deluxe Rooms, 2 Classic Rooms, and 5 Duplex Rooms. Most of the rooms have balconies
                        offering spectacular views of the surroundings or the pool. With contemporary furniture and
                        elegant decor, all rooms ensure utmost comfort. Amenities include an LCD TV with satellite,
                        minibar, and an electronic safe deposit box.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           
<div className="menu-part tab-pane fade facility" id="facility" role="tabpanel">
  <div className="row">
    {/* Basic Facility */}
    <div className="col-xl-3 col-6">
      <h6>
        <img
          src="../assets/images/icon/hotel/verified.png"
          className="img-fluid blur-up lazyloaded"
          alt="Basic Facility"
        />
        {" "}Hotel Facilities
      </h6>
      <ul>
        <li><i className="fas fa-check"></i> Air Conditioning</li>
        <li><i className="fas fa-check"></i> Free WiFie</li>
        <li><i className="fas fa-check"></i> Laundry Service</li>
        <li><i className="fas fa-check"></i> Parking</li>
        <li><i className="fas fa-check"></i> Room Service</li>
      </ul>
    </div>

    {/* Payment Mode */}
    <div className="col-xl-3 col-6">
      <h6>
        <img
          src="../assets/images/icon/hotel/credit-card.png"
          className="img-fluid blur-up lazyloaded"
          alt="Payment Mode"
        />
        {" "}Safety & Security
      </h6>
      <ul>
        <li><i className="fas fa-check"></i>Smoke Detector</li>
        <li><i className="fas fa-check"></i>CCTV</li>
        <li><i className="fas fa-check"></i> Fire Extinguisher</li>
        <li><i className="fas fa-check"></i> First Aid</li>
        
      </ul>
    </div>

    {/* Security */}
    <div className="col-xl-3 col-6">
      <h6>
        <img
          src="../assets/images/icon/hotel/cctv.png"
          className="img-fluid blur-up lazyloaded"
          alt="Security"
        />
        {" "}Additional Services
      </h6>
      <ul>
        <li><i className="fas fa-check"></i> Newspaper</li>
        <li><i className="fas fa-check"></i>Wheelchair Access</li>
        <li><i className="fas fa-check"></i> Airport Transfer</li>
        
      </ul>
    </div>

    {/* Food & Drinks + Activities */}
    <div className="col-xl-3 col-6">
      <h6>
        <img
          src="../assets/images/icon/hotel/tray.png"
          className="img-fluid blur-up lazyloaded"
          alt="Food and Drinks"
        />
        {" "}food & drinks
      </h6>
      <ul>
        <li><i className="fas fa-check"></i> restaurant</li>
        <li><i className="fas fa-check"></i> bar</li>
      </ul>

      
    
    </div>
  </div>
</div>

            {/* Location Tab */}
            <div className="tab-pane fade" id="location" role="tabpanel">
              <div className="card w-100 h-100 border-0 shadow-sm">
                <div className="card-body px-4 py-5">
                  <h4 className="mb-3 text-primary fw-bold">Location Details</h4>
                  <p className="text-muted mb-4">{roomDetails?.location || 'Location details not available.'}</p>
                  <div className="google-map rounded-3 overflow-hidden" style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.7168542751736!2d77.57823599999999!3d30.296953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929e9bd20fbb3%3A0xaa8296cf4a257c29!2sAbhyaranyan!5e0!3m2!1sen!2sin!4v1653647282959!5m2!1sen!2sin"
                      style={{ border: 0, width: '100%', height: '400px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Location Map"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Reviews Tab */}
            <div className="tab-pane fade" id="reviews" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-4">
                   <div className="review-box">
        <div className="rating">
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <h className="fw-bold mb-3">The stay in the hotel was excellent</h>
         
        </div>
       
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
  Our stay at sea view was pleasant. We stayed here for a day and the view from
  the room was brilliant. Rooms were clean hygienic and big. Foods were amazing.
  Rooms were neat and clean. Staff is very courteous and cooperative. Great place
  to stay. Good atmosphere, staff was amazing.. well educated.. mannered. Room was
  spacious and cleaned more than expected.
</p>

      </div>
       <div className="review-box">
        <div className="rating">
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="far fa-star"></i>
          <h className="fw-bold mb-3">Awesome Stay..value for money</h>
         
        </div>
        
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          We were there for 3 nights and hotel was too good. Greenery was flaunting
          everywhere. There were games kept for our entertainment. View from room was
          good. Hotel staff behavior was nice. They provided each and every service in
          hand. Overall stay was too good.
        </p>
      </div>
       <div className="review-box">
        <div className="rating">
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="far fa-star"></i>
          <h className="fw-bold mb-3">Best getaway destination with family</h>
        
        </div>
       
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          The location, view from the rooms are just awesome. Very cool landscaping has
          been done around the hotel. There are small activities that you can indulge with
          your family. Pool wasn't functional at the time of our stay. In all, the stay is
          really peaceful, calm and silent. A place we would definitely want to visit
          again.
        </p>
      </div>
    
                </div>
              </div>
            </div>

            {/* Policies Tab */}
            <div className="tab-pane fade" id="policies" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-4">
                  <h4 className="fw-bold mb-3">Policies</h4>
                  <p className="text-muted">Check-in/Check-out, Cancellation, House rules etc.</p>
                </div>
              </div>
            </div>

          </div> {/* End tab-content */}
        </div>
      </div>
    </div>
  </div>
</section>

        {/* Related Hotels Section */}
        {relatedRooms.length > 0 && (
          <section className="section-b-space bg-white mt-5">
            <div className="container">
              <div className="title-1 title-5">
                <h2>Related Hotels</h2>
                <p>Explore other amazing options that might interest you</p>
              </div>
              <div className="row">
                {relatedRooms.map(room => (
                  <div className="col-lg-4 col-md-4 mb-4" key={room.id}>
                    <div className="hotel-box">
                      <div className="hotel-image">
                        <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                          <img
                            src={`https://admin.abhyaranyan.com/RoomsUploadimage/${room.roomImage}`}
                            className="img-fluid"
                            alt={room.roomType}
                          />
                          {room.isSpecial && (
                            <div className="special-label">
                              <span>Special</span>
                            </div>
                          )}
                        </Link>
                      </div>
                      <div className="hotel-details">
                        <div className="hotel-info">
                          <div className="hotel-title-box">
                            <h5>
                              <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                                {room.roomType}
                              </Link>
                            </h5>
                            <h6><i className="fas fa-map-marker-alt"></i> {room.location}</h6>
                          </div>
                        </div>
                        <div className="hotel-price">
                          {room.oldRent > room.rent && (
                            <del>₹{room.oldRent}</del>
                          )}
                          <h6>₹{room.rent}</h6>
                          <Link
                            to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}
                            className="btn btn-solid btn-sm"
                          >
                            Book Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Viewroomdetails;
